import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Compbaser } from "../../../../components/compbaser";
import {LocalStoreService, SceneService, StoreSelectorsService} from "../../../../services";
import { actionUpdateSceneItem } from "../../../../store/actions/user.actions";
import {
    Id,
    IAnchorProps,
    IPlayerProps,
    ISceneTreeSliceResults,
    ISceneBlock
} from "../../../../interfaces";
import { isBooleanString, isDigit, isSceneButNotSubScene, isNullOrUndef } from "../../../../common";
import * as _ from 'lodash';

const intKeys = ['left', 'right', 'top', 'bottom', 'width', 'verticalCenter', 'horizontalCenter', 'height', 'x', 'y'];
const checkedKeys = ['left', 'right', 'top', 'bottom', 'verticalCenter', 'horizontalCenter'];

@Component({
    selector: 'app-block-layout-common-props',
    templateUrl: './block-layout-props-common.component.html',
    styleUrls: ['./block-layout-common-props.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BlockLayoutCommonPropsComponent extends Compbaser implements OnInit {
    sceneSpecificProps = false;
    private sceneId: Id;
    private sceneItem: ISceneBlock;
    readonly model: IAnchorProps = {
        label: null,
        autoScaling: null,
        rotation: null,
        left: null,
        right: null,
        top: null,
        bottom: null,
        verticalCenter: null,
        horizontalCenter: null,
        width: null,
        height: null,
        x: null,
        y: null,
        locked: null
    };
    originModel: IAnchorProps;
    sceneWidth = 0;
    sceneHeight = 0;

    // Resolution presets
    resolutionPresets = [
        '1920x1080',
        '1366x768',
        '1536x864',
        '1280x720',
        '1024x768',
        '1440x900',
        '1600x900',
        '1280x800',
        '1280x1024',
        '1680x1050',
        '360x800',
        '390x844',
        '393x873',
        '412x915',
        '360x640',
        '414x896',
        '375x812',
        '768x1024',
        '1280x800',
        '800x1280',
        '1080x1920',
        '768x1366',
        '864x1536',
        '720x1280',
        '768x1024',
        '900x1440',
        '900x1600',
        '800x1280',
        '1024x1280',
        '1050x1680',
        '800x360',
        '844x390',
        '873x393',
        '915x412',
        '640x360',
        '896x414',
        '812x375',
        '1024x768',
        '800x1280',
        '1280x800'
    ];

    constructor(
        private storeSelector: StoreSelectorsService,
        private cd: ChangeDetectorRef,
        private sceneService: SceneService,
        private localStoreService: LocalStoreService
    ) {
        super();
    }

    ngOnInit() {
        this.cod(
            this.storeSelector.listenPlayerDataOfSelectedSceneItemId()
                .subscribe((i_sceneSlice: ISceneTreeSliceResults) => {
                    this.sceneId = i_sceneSlice.sceneId;
                    this.sceneItem = i_sceneSlice.sceneItem;
                    isSceneButNotSubScene(this.sceneItem) ? this.sceneSpecificProps = false : this.sceneSpecificProps = true;
                    const layout = i_sceneSlice.sceneItem.Data["0"].Layout["0"].$;
                    this.updateModel(layout);

                    this.model.label = i_sceneSlice.sceneItem.$.label;
                    this.model.autoScaling = _.isUndefined(i_sceneSlice.sceneItem.$.autoScaling) ? '0' : i_sceneSlice.sceneItem.$.autoScaling;
                    this.originModel = _.cloneDeep(this.model);
                    this.cd.markForCheck();
                })
        );
        this.cod(
            this.storeSelector.listenSelectedScene().subscribe((i_scene: IPlayerProps) => {
                if (i_scene && i_scene.Player) {
                    const i_sceneLayout = i_scene.Player.Data[0].Layout[0].$;
                    this.sceneWidth = +i_sceneLayout.width;
                    this.sceneHeight = +i_sceneLayout.height;
                }
            })
        );
    }

    private updateModel(layout) {
        Object.keys(this.model).forEach((k) => {
            if (k.includes("Checked")) return;
            this.model[k] = layout && !isNullOrUndef(layout[k]) ? layout[k] : null;

            if (!isNullOrUndef(this.model[k]) && intKeys.indexOf(k) > -1) {
                this.model[k] = Math.round(this.model[k]);
            }
            if (checkedKeys.indexOf(k) > -1) {
                this.model[`${k}Checked`] = !isNullOrUndef(this.model[k]);
            }
        });
        if (this.model.leftChecked || this.model.rightChecked) {
            this.model.x = null;
        }
        if (this.model.topChecked || this.model.bottomChecked) {
            this.model.y = null;
        }
        this.cd.detectChanges();
    }

    onChangeScaling(value) {
        this.model.autoScaling = value ? '1' : '0';
        const values: any = [{
            key: 'autoScaling',
            value: this.model.autoScaling,
            storePath: '$'
        }];

        const newModel = _.cloneDeep(this.model);

        if (newModel.autoScaling === '1') {
            if (newModel.leftChecked && newModel.rightChecked) {
                newModel.width = this.sceneWidth - newModel.left - newModel.right;
                newModel.x = newModel.left;
            } else if (newModel.rightChecked) {
                newModel.x = this.sceneWidth - newModel.width - newModel.right;
            } else if (newModel.leftChecked) {
                newModel.x = newModel.left;
            } else if (newModel.horizontalCenterChecked) {
                newModel.x = Math.round((this.sceneWidth - newModel.width) / 2) + (newModel.horizontalCenter || 0);
            }

            if (newModel.topChecked && newModel.bottomChecked) {
                newModel.height = this.sceneHeight - newModel.top - newModel.bottom;
                newModel.y = newModel.top;
            } else if (newModel.bottomChecked) {
                newModel.y = this.sceneHeight - newModel.height - newModel.bottom;
            } else if (newModel.topChecked) {
                newModel.y = newModel.top;
            } else if (newModel.verticalCenterChecked) {
                newModel.y = Math.round((this.sceneHeight - newModel.height) / 2) + (newModel.verticalCenter || 0);
            }

            Object.keys(newModel).forEach((k) => {
                if (k === 'label' || k === 'autoScaling') {
                    delete newModel[k];
                } else if (checkedKeys.indexOf(k) > -1) {
                    delete newModel[k];
                    delete newModel[`${k}Checked`];
                } else {
                    newModel[k] = `${newModel[k]}`;
                }
            });

            values.push({
                key: '$',
                value: newModel,
                storePath: 'Data["0"].Layout["0"]'
            });
            this.updateModel(newModel);
        }

        this.storeSelector.dispatch(actionUpdateSceneItem({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItem.$.id,
            values
        }));
        this.cd.markForCheck();
    }

    onNumberSelectorChange(field: string, value: number) {
        this.model[field] = value;
        this.onChange(field);
    }

    onResolutionPresetSelected(resolution: string) {
        if (!resolution) return;

        const [width, height] = resolution.split('x').map(val => parseInt(val, 10));

        if (width && height) {
            this.model.width = width;
            this.model.height = height;

            // Update both dimensions
            this.onChange('width');
            setTimeout(() => {
                this.onChange('height');
            }, 50);
        }
    }

    onChange(i_from, islocked?: boolean, updatedRotation?: number) {
        const defValue = 100;
        const newModel = _.cloneDeep(this.model);

        if (i_from === 'width' || i_from === 'height') {
            if (this.sceneSpecificProps) {
                if (newModel.width && newModel.width > this.sceneWidth) newModel.width = this.sceneWidth;
                if (newModel.height && newModel.height > this.sceneHeight) newModel.height = this.sceneHeight;
                if (newModel.width && newModel.width < 10) newModel.width = 10;
                if (newModel.height && newModel.height < 10) newModel.height = 10;
            } else {
                newModel.width = Math.max(Math.min(newModel.width, 8192), 50);
                newModel.height = Math.max(Math.min(newModel.height, 8192), 50);
            }
        }

        newModel.rotation = updatedRotation || updatedRotation == 0 ? updatedRotation : newModel.rotation;

        switch (i_from) {
            case 'left': {
                // set left
                if (newModel.leftChecked) {  // if checked left
                    if (isNullOrUndef(newModel.left)) {
                        if (isNullOrUndef(this.originModel.left)) {
                            if (newModel.rightChecked) {
                                newModel.left = this.sceneWidth - newModel.right - newModel.width;
                            } else {
                                newModel.left = isNullOrUndef(newModel.x) ? defValue : newModel.x;
                            }
                        } else {
                            newModel.left = 0;
                        }
                        newModel.x = newModel.left;
                    }
                } else {
                    delete newModel.left;
                    if (newModel.rightChecked) {
                        newModel.width = this.sceneWidth - this.originModel.right - this.originModel.left;
                    } else {
                        newModel.x = this.originModel.left;
                    }
                }

                // set width
                if (!newModel.leftChecked || !newModel.rightChecked) {
                    if (!newModel.width) newModel.width = defValue;
                } else {
                    // delete newModel.width;
                    newModel.width = this.sceneWidth - newModel.left - newModel.right;
                }

                delete newModel.horizontalCenter;
                break;
            }
            case 'right': {
                // set right
                if (newModel.rightChecked) {   // if checked right
                    if (isNullOrUndef(newModel.right)) {
                        if (isNullOrUndef(this.originModel.right)) {
                            if (newModel.leftChecked) {
                                newModel.right = this.sceneWidth - newModel.left - newModel.width;
                            } else {
                                newModel.right = this.sceneWidth - newModel.x - newModel.width;
                            }
                        } else {
                            newModel.right = 0;
                        }
                    }

                } else {
                    delete newModel.right;
                    if (newModel.leftChecked) {
                        newModel.width = this.sceneWidth - this.originModel.right - this.originModel.left;
                    } else {
                        newModel.x = this.sceneWidth - this.originModel.width - this.originModel.right;
                    }
                }

                // set width
                if (!newModel.leftChecked || !newModel.rightChecked) {
                    if (!newModel.width) newModel.width = defValue;
                } else {
                    // delete newModel.width;
                    newModel.width = this.sceneWidth - newModel.left - newModel.right;
                }

                delete newModel.horizontalCenter;
                break;
            }
            case 'top': {
                // set top
                if (newModel.topChecked) {  // if checked top
                    if (isNullOrUndef(newModel.top)) {
                        if (isNullOrUndef(this.originModel.top)) {
                            if (newModel.bottomChecked) {
                                newModel.top = this.sceneHeight - newModel.bottom - newModel.height;
                            } else {
                                newModel.top = isNullOrUndef(newModel.y) ? defValue : newModel.y;
                            }
                        } else {
                            newModel.top = 0;
                        }
                        newModel.y = newModel.top;
                    }
                } else {
                    delete newModel.top;
                    if (newModel.bottomChecked) {
                        newModel.height = this.sceneHeight - this.originModel.bottom - this.originModel.top;
                    } else {
                        newModel.y = this.originModel.top;
                    }
                }

                // set height
                if (!newModel.topChecked || !newModel.bottomChecked) {
                    if (!newModel.height) newModel.height = defValue;
                } else {
                    // delete newModel.height;
                    newModel.height = this.sceneHeight - newModel.top - newModel.bottom;
                }

                delete newModel.verticalCenter;
                break;
            }
            case 'bottom': {
                // set bottom
                if (newModel.bottomChecked) {   // if checked bottom
                    if (isNullOrUndef(newModel.bottom)) {
                        if (isNullOrUndef(this.originModel.bottom)) {
                            if (newModel.topChecked) {
                                newModel.bottom = this.sceneHeight - newModel.top - newModel.height;
                            } else {
                                newModel.bottom = this.sceneHeight - newModel.y - newModel.height;
                            }
                        } else {
                            newModel.bottom = 0;
                        }
                    }

                } else {
                    delete newModel.bottom;
                    if (newModel.topChecked) {
                        newModel.height = this.sceneHeight - this.originModel.bottom - this.originModel.top;
                    } else {
                        newModel.y = this.sceneHeight - this.originModel.bottom - this.originModel.height;
                    }
                }

                // set width
                if (!newModel.topChecked || !newModel.bottomChecked) {
                    if (!newModel.height) newModel.height = defValue;
                } else {
                    // delete newModel.height;
                    newModel.height = this.sceneHeight - newModel.top - newModel.bottom;
                }

                delete newModel.verticalCenter;
                break;
            }
            case 'horizontalCenter': {
                if (newModel.horizontalCenterChecked) {
                    if (isNullOrUndef(newModel.horizontalCenter)) {
                        newModel.horizontalCenter = 0;
                    }
                    newModel.horizontalCenter = Math.min(newModel.horizontalCenter, this.sceneWidth / 2);
                } else {
                    delete newModel.horizontalCenter;
                }

                // set width
                if (newModel.leftChecked && newModel.rightChecked) {
                    newModel.width = this.sceneWidth - newModel.left - newModel.right;
                } else {
                    newModel.width = newModel.width || defValue;
                }
                newModel.x = Math.round((this.sceneWidth - newModel.width) / 2) + (newModel.horizontalCenter || 0);

                delete newModel.left;
                delete newModel.right;
                break;
            }
            case 'verticalCenter': {
                if (newModel.verticalCenterChecked) {
                    if (isNullOrUndef(newModel.verticalCenter)) {
                        newModel.verticalCenter = 0;
                    }
                    newModel.verticalCenter = Math.min(newModel.verticalCenter, this.sceneHeight / 2);
                } else {
                    delete newModel.verticalCenter;
                }

                // set height
                if (newModel.topChecked && newModel.bottomChecked) {
                    newModel.height = this.sceneHeight - newModel.top - newModel.bottom;
                } else {
                    newModel.height = newModel.height || defValue;
                }
                newModel.y = Math.round((this.sceneHeight - newModel.height) / 2) + (newModel.verticalCenter || 0);

                delete newModel.top;
                delete newModel.bottom;
                break;
            }
            case 'x': {
                delete newModel.left;
                delete newModel.right;
                delete newModel.horizontalCenter;
                break;
            }
            case 'y': {
                delete newModel.top;
                delete newModel.bottom;
                delete newModel.verticalCenter;
                break;
            }
            case 'width': {
                if (newModel.left !== null && newModel.right !== null) {
                    delete newModel.left;
                    delete newModel.right;
                }
                break;
            }
            case 'height': {
                if (newModel.top !== null && newModel.bottom !== null) {
                    delete newModel.top;
                    delete newModel.bottom;
                }
                break;
            }
            case 'lock': {
                newModel.locked = islocked ? 'true' : 'false';
                break;
            }
            case 'label': {
                this.storeSelector.dispatch(actionUpdateSceneItem({
                    sceneId: this.sceneId,
                    sceneItemId: this.sceneItem.$.id,
                    values: [{
                        key: 'label',
                        value: newModel.label,
                        storePath: '$'
                    }]
                }));
                this.storeSelector.dispatch({ type: 'BREAK_MERGE' });
                return;
            }
        }

        delete newModel.leftChecked;
        delete newModel.rightChecked;
        delete newModel.topChecked;
        delete newModel.bottomChecked;
        delete newModel.horizontalCenterChecked;
        delete newModel.verticalCenterChecked;

        Object.keys(newModel).forEach((k) => {
            if (isNullOrUndef(newModel[k]) || k === 'label' || k === 'autoScaling') {
                delete newModel[k];
            } else if (!isDigit(newModel[k]) && !isBooleanString(newModel[k])) {
                newModel[k] = 0;
            } else {
                newModel[k] = `${newModel[k]}`;
            }
        });

        this.updateModel(newModel);

        this.storeSelector.dispatch(actionUpdateSceneItem({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItem.$.id,
            values: [{
                key: '$',
                value: newModel,
                storePath: 'Data["0"].Layout["0"]',
                cloneValue: true
            }]
        }));

        // change background image size when scene width/height is changed
        if (!this.sceneSpecificProps && (i_from === 'width' || i_from === 'height')) {
            this.sceneService.updateSceneItemLayout(null, {
                [i_from]: newModel[i_from]
            }, true);
        }

        this.storeSelector.dispatch({ type: 'BREAK_MERGE' });
        this.cd.markForCheck();
    }
}
